import {
    FETCH_CONNECTIONS_LEADERBOARD_START,
    FETCH_CONNECTIONS_LEADERBOARD_SUCCESS,
    FETCH_CONNECTIONS_LEADERBOARD_FAIL,
    REFETCH_CONNECTIONS_LEADERBOARD
} from 'actions/ActionTypes.js';

const INITIAL_STATE = {
    leaderboardList: [],
    connectionsLeaderboardFetching: false,
    connectionsLeaderboardFetchFail: false,
    refetchTS: 0
};

// ======= Fetching Handlers =======
const fetchConnectionsLeaderboardFetching = (state) => {
    return {
        ...state,
        connectionsLeaderboardFetching: true,
        connectionsLeaderboardFetchFail: false
    };
};

const fetchConnectionsLeaderboardSuccess = (state, action) => {
    const { metricsMap } = action.data.allMetrics;
    return {
        ...state,
        leaderboardList:
            metricsMap.WELLNESS_TOTAL_PUSHES ||
            metricsMap.WELLNESS_TOTAL_STEPS ||
            metricsMap.ACTIVITY_TOTAL_DISTANCE ||
            [],
        connectionsLeaderboardFetching: false,
        connectionsLeaderboardFetchFail: false
    };
};

const fetchConnectionsLeaderboardFail = (state) => {
    return {
        ...state,
        connectionsLeaderboardFetching: false,
        connectionsLeaderboardFetchFail: true
    };
};

/** handle re-fetch */
const updateConnectionLeaderboardRefetchTS = (state) => {
    return {
        ...state,
        refetchTS: Date.now()
    };
};

export const getConnectionsLeaderboardFetching = (state) => state.connectionsLeaderboard.connectionsLeaderboardFetching;
export const getConnectionsLeaderboardList = (state) => state.connectionsLeaderboard.leaderboardList;
export const getConnectionsLeaderboardRefetchTS = (state) => state.connectionsLeaderboard.refetchTS;

// ======= Handler Assignments =======
const handlers = {
    [FETCH_CONNECTIONS_LEADERBOARD_START]: fetchConnectionsLeaderboardFetching,
    [FETCH_CONNECTIONS_LEADERBOARD_SUCCESS]: fetchConnectionsLeaderboardSuccess,
    [FETCH_CONNECTIONS_LEADERBOARD_FAIL]: fetchConnectionsLeaderboardFail,
    [REFETCH_CONNECTIONS_LEADERBOARD]: updateConnectionLeaderboardRefetchTS
};

// ======= Default Action ======
export default function connectionsLeaderboard(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
